export type payloadProps = {
  code: string;
  name: string;
};

export enum payloadSubmitType {
  DRAFT = "draft",
  SUBMIT = "submit",
}

export enum DNDFieldsEnum {
  BUILDINGCODE = "code",
  BUILDINGNAME = "name",
  ROOMFEATURECODE = "code",
  ROOMFEATURENAME = "name",
  ROOMLOCATIONCODE = "code",
  ROOMLOCATIONNAME = "name",
  HOUSEKEEPINGCODE = "code",
  HOUSEKEEPINGNAME = "name",
  ROOMTYPECODE = "code",
  ROOMTYPENAME = "name",
  ROOMDEFINITIONCODE = "roomTypeCode",
  ROOMDEFINITIONNAME = "roomNumber",
  DEPARTMENTCODE = "name",
  CATEGORYCODE = "name",
  TAXCODE = "taxType",
  TAXNAME = "taxName",
  TAXEXEMPTCODE = "code",
  TAXEXEMPTNAME = "name",
  POSTTYPECODE = "postTypeNumber",
  POSTTYPENAME = "postTypeName",
  GUESTTYPECODE = "code",
  GUESTTYPENAME = "name",
  ORIGINCODE = "code",
  ORIGINNAME = "name",
  PAYMENTCODE = "code",
  PAYMENTNAME = "name",
  SEGMENT1CODE = "code",
  SEGMENT1NAME = "name",
  SEGMENT2CODE = "code",
  SEGMENT2NAME = "name",
  TRANSPORTATIONCODE = "code",
  TRANSPORTATIONNAME = "name",
  ALLOCATIONBLOCKCODE = "Allocation Block Code",
  ALLOCATIONBLOCKNAME = "Allocation Block Name",
  COLOROPTIONS = "Color Options",
  COURSENAME = "Course Name",
  CATEGORYGROUP = "Category Group",
  DISCOUNTREASON = "Discount Reason",
  DISCOUNTTYPE = "Discount Type",
  OUTLETNAME = "Outlet Name",
  QUICKSALECATEGORY = "Quick Sale Category",
  COURSE = "Course",
  COURSES = "Courses",
  RATETYPE = "Rate Type",
  RATETYPE_CAMEL = "RateType",
  CATEGORYNAME = "Category Name",
  SUBCATEGORY1 = "Subcategory1",
  SUBCATEGORY2 = "Subcategory2",
  SUBCATEGORY3 = "Subcategory3",
  SUBCATEGORY4 = "Subcategory4",
  SUBCATEGORY5 = "Subcategory5",
  ROLECODE = "Role Code",
  ROLENAME = "Role Name",
  VENDORTYPE = "Vendor Type",
  NUMBEROFMINUTES = "# of Minutes",
  OUTLET = "Outlet",
  TAXNAME2 = "Tax Name",
  AVAILABLEONWEB = "Available on Web",
  HOLENUMBER = "Hole Number",
  PLAYERTYPE = "Player Type",
  TERMINALID = "Terminal ID",
  ACTIVE = "Active",
  DEFAULTOUTLET = "Default Outlet",
  STARTDATE = "Start Date",
  CANCELREASONS = "Cancel Reasons",
  DEFAULT = "Default",
  LESSONLOCATION = "Lesson Locations",
  TEMPLATECODE = "Template Code",
  TEMPLATENAME = "Template Name",
  STARTTIME = "Start Time",
  ENDTIME = "End Time",
  INTERVALMINS = "Interval Minutes",
  VENDORCODE = "Vendor Code",
  VENDORNAME = "Vendor Name",
  FIRSTNAME = "First Name",
  LASTNAME = "Last Name",
  ADDRESS = "Address",
  CITY = "City",
  STATE = "State",
  COUNTRY = "Country",
  POSTALCODE = "Postal Code",
  MOBILE = "Mobile",
  EMAIL = "Email",
  COMMENTS = "Comments",
  // SPA
  SERVICEGROUPCODE = "Service Group Code",
  SERVICEGROUPNAME = "Service Group Name",
  LISTORDER = "List Order",
  LOCATIONCODE = "Location Code",
  LOCATIONNAME = "Location Name",
  EQUIPMENTCODE = "Equipment Code",
  EQUIPMENTNAME = "Equipment Description",
  CANCELREASONDESCRIPTION = "Cancel Reason Description",
  NOSHOWREASONDESCRIPTION = "No Show Reason Description",
  BREAKCODE = "Break Code",
  BREAKNAME = "Break Name",
  REASONDESCRIPTION = "Reason Description",
  LOGTYPENAME = "Log Type Name",
  SPAGUESTTYPECODE = "Guest Type Code",
  SPAGUESTTYPENAME = "Guest Type Name",
  SPAPRICETYPECODE = "Price Type Code",
  SPAPRICETYPEDESCRIPTION = "Price Type Description",
  SERVICECODE = "Service Code",
  SERVICEDESCRIPTION = "Service Description",
  ADDONNAME = "Add On Name",
  PACKAGECODE = "Package Code",
  PACKAGEDESCRIPTION = "Package Description",
  PAYMENTMETHODNAME = "Payment Method Name",
  CONDITIONCODE = "Condition Code",
  CONDITIONNAME = "Condition Description",
  STAFFCODE = "Staff Code",
  ITEMNUMBER = "Item Number",
  ARRIVALTYPECODE = "Arrival Type Code",
  ARRIVALTYPENAME = "Arrival Type Name",
  USERID = "User ID",
  NONE = "None",
  PRICE = "Price",
}

export enum buttonValues {
  UPDATE = "Update ",
  ADD = "Add ",
}

export interface serviceResponse {
  response: any;
  status: number;
}

export enum userRoleEnum {
  CUSTOMER = "Customer",
  AGILYSYS = "Agilysys",
  ADMIN = "Admin",
}
